import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=1d4adf9e&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports